<template>
    <div class="story-maker-highlight-menu">
        <div class="btns-action">
            <div class="btn cancel" @click="close">
                <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
            </div>
        </div>
     
        <div class="bottom-sheet">
            <template v-if="highlights && Array.isArray(highlights)">
                <template v-if="(!highlights.length && !story.highlight.text) || section == 'newHighlight'">
                    <h4>{{ $t('dash.post-creator.story.highlight.new') }}</h4>
                    <div class="content-new-highlight">
                        <div class="container-highlight-picture">
                            <div class="highlight-picture">
                                <div class="container-img" :style="{backgroundColor : story.background.color}">
                                    <template v-if="story.background.file && story.background.file.id && files[story.background.file.id]">
                                        <img v-if="files[story.background.file.id].info.type2 == 'image'" :src="files[story.background.file.id].url">
                                        <video v-else-if="files[story.background.file.id].info.type2 == 'video'" :src="files[story.background.file.id].url" :type="files[story.background.file.id].info.type" muted loop playsinline preload="metadata" class="source" onloadedmetadata="true">
                                        </video>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <input :placeholder="$t('dash.post-creator.story.highlight.name-placeholder')" v-model="models.highlightName">
                        <div class="button"  @click="addHighlight" v-if="models.highlightName.length">
                            {{ $t('dash.post-creator.story.highlight.add-button') }}
                        </div>
                        <div class="button" @click="()=> {
                            if (!highlights.length) { close() }else{ section = 'home' }
                        }" v-else>
                            {{ $t('dash.button.go_back') }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <h4>{{ $t('dash.post-creator.story.highlight.add-to') }}</h4>
                    <div class="content-pick-highlight">
                        <div class="list hide-scrollbar">
                            
                            <template>
                                <div class="container-highlight-new" @click="section = 'newHighlight'">
                                    <div class="highlight-icon">
                                        <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                                    </div>
                                    <p>{{ $t('dash.post-creator.story.highlight.new-label') }}</p>
                                </div>

                                <div v-if="!story.highlight.id && story.highlight.text" class="container-highlight-picture selected" @click="unSelectHighlight">
                                    <div class="highlight-picture">
                                        <div class="container-img" :style="{backgroundColor : story.background.color}">
                                            <template v-if="story.background.file && story.background.file.id && files[story.background.file.id]">
                                                <img v-if="files[story.background.file.id].info.type2 == 'image'" :src="files[story.background.file.id].url">
                                                <video v-else-if="files[story.background.file.id].info.type2 == 'video'" :src="files[story.background.file.id].url" :type="files[story.background.file.id].info.type" muted loop playsinline preload="metadata" class="source" onloadedmetadata="true">
                                                </video>
                                            </template>
                                        </div>
                                    </div>
                                    <p>{{ story.highlight.text }}</p>
                                </div>

                                <div class="container-highlight-picture" :class="{selected:story.highlight.id == highlight.id}" @click="()=>selectHighlight(highlight)" v-for="highlight in highlights">
                                    <div class="highlight-picture">
                                        <div class="container-img">
                                            <img :src="highlight.img">
                                        </div>
                                    </div>
                                    <p>{{ highlight.title }}</p>
                                </div>
                            </template>
                           
                            
                        </div>
                        <div class="button" @click="close">
                            {{ $t('dash.button.close') }}
                        </div>
                    </div>
                </template>
                
            </template>
            <span class="loader" v-else></span>
            
        </div>
      

    </div>
</template>

<script>
    export default {
        props: {
            highlights: Array,
            story: Object,
            files:Object
        },
        data() {
            return {
                models: {
                    highlightName : ''
                },
                section: 'home',
            }
        },

        methods: {
            close() {
              this.$emit('close')  
            },

            addHighlight() {
                //mettre text dans la stry
                this.$emit('updateHighlight', {
                    id: null,
                    text: this.models.highlightName,
                })
                this.$set(this.models, 'highlightName', '')
                this.section = 'home'
            },

            selectHighlight(highlight) {
                if (highlight.id == this.story.highlight.id) {
                    this.unSelectHighlight()
                }else{
                    this.$emit('updateHighlight', {
                        id: highlight.id,
                        text: highlight.title,
                    })
                }
            },
            unSelectHighlight() {
                this.$emit('updateHighlight', {
                    id: null,
                    text: null,
                })
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>